<template>
  <article ref="card" class="magic-card" :style="cardStyle" @pointermove="onPointerMove" @pointerleave="reset">
    <div class="magic-card-glow"></div>
    <slot />
  </article>
</template>

<script setup>
import { ref } from "vue";

const card = ref(null);
const cardStyle = ref({ "--mouse-x": "50%", "--mouse-y": "50%" });
function onPointerMove(event) {
  const rect = card.value?.getBoundingClientRect();
  if (!rect) return;
  cardStyle.value = {
    "--mouse-x": `${event.clientX - rect.left}px`,
    "--mouse-y": `${event.clientY - rect.top}px`,
  };
}
function reset() {
  cardStyle.value = { "--mouse-x": "50%", "--mouse-y": "50%" };
}
</script>
